export default "__VITE_ASSET__CISRcNhe__"